const VueUtils = require('../../../modules/vue-utils');

let $bookingApp, $selectCoverage, $submitButton;

function _setupForVueApp() {
    $selectCoverage = VueUtils.getRef('booking-insurance');
    $submitButton = $bookingApp.querySelector('input[type="submit"]');

    if (!$selectCoverage) {
        console.warn('Could not find required insurance element or button');
        return;
    }

    $submitButton.disabled = true;

    $bookingApp.addEventListener('booking-insurance-selector:started-loading', event => {
        $submitButton.disabled = true;
    });


    $bookingApp.addEventListener('booking-insurance-selector:finished-loading', event => {
        $submitButton.disabled = false;
    });
}

function _setupCoverageUpdates() {
    const $el = document.querySelector('.detailCard.controls .charge');

    if (!$el) {
        return;
    }

    const originalTotal = parseFloat($el.dataset.originalTotal);

    $bookingApp.addEventListener('booking-instance-selector:changed-coverage', event => {
        if (!event.detail || typeof event.detail.totalAmount === 'undefined') {
            return;
        }

        const newTotal = originalTotal + event.detail.totalAmount;
        $el.innerText = newTotal.toFixed(2);
    });

}


document.addEventListener('DOMContentLoaded', () => {
    $bookingApp = document.querySelector('#booking-app');

    if (!document.querySelector('html.make-booking.select-extras') || !$bookingApp) {
        return;
    }

    //temporarily disabling coverage options
    // _setupForVueApp();


    // _setupCoverageUpdates();
});
